import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatterCounts, MatterFileType } from '@models/matter';

@Component({
	selector: 'app-matter-count-icons',
	templateUrl: './matter-count-icons.component.html',
	styleUrls: ['./matter-count-icons.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterCountIconsComponent {
	MATTER_FILE_TYPE = MatterFileType;

	@Input() counts!: MatterCounts;
	@Input() showIfZero = true;
	@Input() zeroDisplayAs = '0';
}
